import { render } from "./ConsultarSaldoArea.vue?vue&type=template&id=f706d726"
import script from "./ConsultarSaldoArea.vue?vue&type=script&lang=js"
export * from "./ConsultarSaldoArea.vue?vue&type=script&lang=js"

import "./ConsultarSaldoArea.vue?vue&type=style&index=0&id=f706d726&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__